import {json_apply_modifications} from "@/prototype/utils/JSON.js";

import global from "@/prototype/global.js";

const d3 = global.d3;
const log = global.log.getLogger("f_mtac.scene.tracking");
log.setLevel(log.levels.WARN);

let Tracking = function (svg, objects) {
    var context = null;

    Object.defineProperty(this, "active", {
        set: () => {},
        get: () => context !== null && "tracking_resource_id" in context.runtime_data
    });

    Object.defineProperty(this, "tracked", {
        set: () => {},
        get: () => {
            if (context === null) {
                return undefined;
            }
            return context.runtime_data.tracking_resource_id;
        }
    });

    const M = 20; // margin
    const L = 100; // line height
    const MB = 30; // bottom margin to compensate text
    const SW = 5; // stroke width

    // positions of X, Y from center
    const X = (x, y, w) => [x + 0, x + w, x + 0, x - w];
    const Y = (x, y, h) => [y - h, y + 0, y + h, y + 0];

    const target = d3.create("svg:g").attr("class", "tracking");
    for (let n = 0; n < 4; n++) {
        target.append("line").attr("class", "lineTracking").attr("stroke-width", SW).style("stroke", "var(--grid-color)");
    }

    const tracking_create = (node) => {
        var {x, y, width: w, height: h} = node.select("g.figure").node().getBBox();

        target.attr("transform", node.attr("transform"));

        h /= 2;
        w /= 2;
        x += w;
        y += h; // moving to center

        h += M;
        w += M; // adding a margin
        const X1 = X(x, y, w),
            Y1 = Y(x, y, h);

        h += L;
        w += L; // adding line height
        const X2 = X(x, y, w),
            Y2 = Y(x, y, h);

        const text = node.select("g.name").select("text.name");
        if (text.size() !== 0) {
            Y1[2] += MB; /*Y2[2] += MB;*/ // adding bottom margin
        }

        target
            .selectAll(".lineTracking")
            .attr("x1", (_, n) => X1[n])
            .attr("y1", (_, n) => Y1[n])
            .attr("x2", (_, n) => X2[n])
            .attr("y2", (_, n) => Y2[n]);
        global.scene.objects.layers.resources.group.node().appendChild(target.node());
    };

    const tracking_remove = () => {
        target.remove();
    };

    this.track = (local_id) => {
        log.debug("Tracking.track:", local_id);
        if (context === null) {
            return;
        }
        context.runtime_data.tracking_resource_id = local_id;
        let object = objects.get_by_id("resources", local_id);
        if (object === undefined) {
            return;
        }
        let {x, y, width, height} = object.handle.node().getBBox();
        tracking_create(object.node);
        global.tools.tools["recenter"].disable();
        global.tools.tools["geocoding"].disable();
        global.view.lock_position({x, y, width, height});
    };

    this.untrack = () => {
        log.debug("Tracking.untrack");
        if (context === null) {
            return;
        }
        delete context.runtime_data.tracking_resource_id;
        tracking_remove();
        global.view.unlock_position();
        global.tools.tools["recenter"].enable();
        global.tools.tools["geocoding"].enable();
    };

    const object_on_creating = ({local_id}) => {
        let tracking_resource_id = this.tracked;
        if (tracking_resource_id !== local_id) {
            return;
        }
        this.track(local_id);
    };

    const object_on_updating = ({local_id, object_data}, modifications) => {
        let tracking_resource_id = this.tracked;
        if (tracking_resource_id !== local_id) {
            return;
        }
        json_apply_modifications(object_data, "object_data", modifications);
        target.attr("transform", object_data.attributes.transform);
    };

    const object_on_deleting = ({local_id}) => {
        let tracking_resource_id = this.tracked;
        if (tracking_resource_id !== local_id) {
            return;
        }
        tracking_remove();
    };

    const handle_on_creating = (handle) => {
        let tracking_resource_id = this.tracked;
        if (tracking_resource_id !== handle.id) {
            return;
        }
        let {x, y, width, height} = handle.getBBox();
        global.view.lock_position({x, y, width, height});
    };

    objects.layers.resources.on("creating", handle_on_creating);

    global.event_bus.subscribe("storage.context.changed", async ({old_context, new_context}) => {
        if (old_context !== null) {
            tracking_remove();
            global.view.unlock_position();
            old_context.off("objects", "creating", object_on_creating);
            old_context.off("objects", "updating", object_on_updating);
            old_context.off("objects", "deleting", object_on_deleting);
        }
        context = new_context;
        if (new_context !== null) {
            new_context.on("objects", "creating", object_on_creating);
            new_context.on("objects", "updating", object_on_updating);
            new_context.on("objects", "deleting", object_on_deleting);
        }
    });

    global.event_bus.subscribe("user.level.changed", () => {
        if (global.storage.shared() && !(global.configuration.profiles[global.configuration.user.level].rights & global.configuration.rights.PROFILE_RIGHTS_WRITE)) {
            // User without write rights (observer)
            this.untrack();
        }
    });
};

export default Tracking;
